export const storage = localStorage;

export const getItemFromStorage = ({name}) => JSON.parse(storage.getItem(name));

export const setDataInStorage = ({ name, data }) => storage.setItem(name, JSON.stringify(data));

